import * as tslib_1 from "tslib";
import { throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from '../base.service';
import { OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
var SpecialService = /** @class */ (function (_super) {
    tslib_1.__extends(SpecialService, _super);
    function SpecialService(http) {
        var _this = _super.call(this, 'topic-item', http) || this;
        _this.http = http;
        return _this;
    }
    SpecialService.prototype.ngOnInit = function () {
    };
    SpecialService.prototype.getAllSpecialByPaging = function (searchCondition, sortOprions, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        var sortStr = sortOprions.getSortString();
        return this.http.get("" + this.url + sortStr + paging.getPagingStr() + (this.embeddedStr + searchCondition) + "&sort=queue,asc").pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    SpecialService.prototype.getAllByBusinessIdByPaging = function (searchCondition, businessId, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        return this.http.get(this.url + "?" + paging.getPagingStr() + (this.embeddedStr + searchCondition) + "&sort=id,desc" + (businessId ? "&f_businessId=" + businessId + "&f_businessId_op==" : '')).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    SpecialService.prototype.getAllByWalletIdsByPaging = function (walletIds, searchCondition, paging) {
        var sortStr = '&sort=id,asc';
        var walletIdsStr = '';
        if (walletIds) {
            walletIds.forEach(function (id) {
                walletIdsStr += "&f_acceptedMerchants=" + id;
            });
        }
        if (walletIdsStr) {
            walletIdsStr += '&f_acceptedMerchants_op=IN';
        }
        return this.http.get(this.url + "?" + paging.getPagingStr() + walletIdsStr + sortStr + searchCondition).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    SpecialService.prototype.publishCouponById = function (id) {
        return this.http.post(this.url + "/" + id + "/dispatch", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    SpecialService.prototype.deleteBusinessRels = function (id) {
        return this.http.post(this.url + "/" + id + "/delete-business", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    SpecialService.prototype.goPromoUp = function (id, topicId) {
        return this.http.post(this.url + "/" + id + "/" + topicId + "/go-promo-up", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    SpecialService.prototype.goPromoDown = function (id, topicId) {
        return this.http.post(this.url + "/" + id + "/" + topicId + "/go-promo-down", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    SpecialService.prototype.goPromoTop = function (id, topicId) {
        return this.http.post(this.url + "/" + id + "/" + topicId + "/go-promo-top", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    SpecialService.prototype.goBusinessUp = function (id, topicId) {
        return this.http.post(this.url + "/" + id + "/" + topicId + "/go-business-up", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    SpecialService.prototype.goBusinessDown = function (id, topicId) {
        return this.http.post(this.url + "/" + id + "/" + topicId + "/go-business-down", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    SpecialService.prototype.goBusinessTop = function (id, topicId) {
        return this.http.post(this.url + "/" + id + "/" + topicId + "/go-business-top", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    SpecialService.prototype.deleteTopicPromo = function (id) {
        return this.http.get(this.url + "/" + id + "/delete-promo-topic").pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    return SpecialService;
}(BaseService));
export { SpecialService };
